document.addEventListener("DOMContentLoaded", function(){
    const body = document.querySelector('body')
    const hamburgerBtn = document.querySelector('.menu-mobile-button .icon-hamburger')
    const closeBtn = document.querySelector('.menu-mobile-button .icon-close') 
    const mobileFooterDropdown = document.querySelectorAll('.menu-mobile-footer .item.has-dropdown')
    const nav2Slider = document.querySelector('.menu-mobile .item.nav2 .submenu-flex')
    const featuredCollectionsSlider = document.querySelector('.featured-collections-submenu-flex')

    hamburgerBtn.addEventListener('click', () => {
        hamburgerBtn.classList.toggle('hide')
        closeBtn.classList.toggle('show')
        body.classList.toggle('mobile-menu-open')
    })

    closeBtn.addEventListener('click', () => {
        hamburgerBtn.classList.toggle('hide')
        closeBtn.classList.toggle('show')
        body.classList.toggle('mobile-menu-open')
    })

    mobileFooterDropdown.forEach(el => {
        el.addEventListener('click', () => {
            console.log('click')
            el.classList.toggle('active')
            el.lastChild.classList.toggle('submenu-open')
        })
    })
    
    if (nav2Slider) {
        $(nav2Slider).slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: false
          })
    }

    if (featuredCollectionsSlider) {
        $(featuredCollectionsSlider).slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: false
          })
    }
  });